import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Websites/List/List';

const WebsitesPage = () => {
  return <Layout fullwidth={0}>
   
      <List></List>
  
  </Layout>;
}

export default WebsitesPage;
